// @flow

import * as React from 'react';
import s from './EmptyTable.scss';

type Props = {
  children?: React.Node,
  limit: number,
  visible: boolean,
}

export const EmptyTable = (props: Props) => {
  const { children, limit, visible } = props;
  if (!visible) return null;

  const cards = [];

  cards.push(<div className={s.blank_header_card} key={limit+1}>
    <span className={s.blank_header_bars}></span>
    <span className={s.blank_header_bars}></span>
    <span className={s.blank_header_bars}></span>
    <span className={s.blank_header_bars}></span>
    <span className={s.blank_header_bars}></span>
    <span className={s.blank_header_bars}></span>
    <span className={s.blank_header_bars}></span>
  </div>);

  for (let i = 0; i < limit; i += 1) {
    if (i === 2) {
      cards.push(
        <div className={s.blank_item_card} key={i}>
          <span className={s.blank_item_bars}></span>
          <span className={s.blank_item_bars}></span>
          <span className={s.blank_item_bars}></span>
          <span className={s.blank_item_bars}>
            {children}
          </span>
          <span className={s.blank_item_bars}></span>
          <span className={s.blank_item_bars}></span>
          <span className={s.blank_item_bars}></span>
        </div>
      );
    } else {
      cards.push(<div className={s.blank_item_card} key={i}>
        <span className={s.blank_item_bars}></span>
        <span className={s.blank_item_bars}></span>
        <span className={s.blank_item_bars}></span>
        <span className={s.blank_item_bars}></span>
        <span className={s.blank_item_bars}></span>
        <span className={s.blank_item_bars}></span>
        <span className={s.blank_item_bars}></span>
      </div>);
    }
  }

  return (
    <div className={s.wrapper}>
      <div className={s.container}>
        <div id={s.blank_card_container}>{cards}</div>
      </div>
    </div>
  )
}

export default EmptyTable;
